const POST_LOGIN_REDIRECT_KEY = "sd-post-login-redirect";
const DEFAULT_TTL = 10 * 60 * 1000; // 10 minutes

interface PostLoginRedirect {
  url: string;
  timestamp: number;
}

export const savePostLoginRedirect = (url: string): void => {
  try {
    const data: PostLoginRedirect = { url, timestamp: Date.now() };
    localStorage.setItem(POST_LOGIN_REDIRECT_KEY, JSON.stringify(data));
  } catch {}
};

/** Whether a fresh saved URL is waiting, without consuming it. */
export const hasPostLoginRedirect = (maxAge = DEFAULT_TTL): boolean => {
  try {
    const raw = localStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    if (!raw) return false;
    const data: PostLoginRedirect = JSON.parse(raw);
    return Date.now() - data.timestamp <= maxAge;
  } catch {
    return false;
  }
};

export const consumePostLoginRedirect = (
  maxAge = DEFAULT_TTL,
): string | null => {
  try {
    const raw = localStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    if (!raw) return null;
    localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    const data: PostLoginRedirect = JSON.parse(raw);
    if (Date.now() - data.timestamp > maxAge) return null;
    return data.url;
  } catch {
    return null;
  }
};
